import { AxiosError } from 'axios/index';
import { toast } from 'react-toastify';
import { ApiError } from 'next/dist/server/api-utils';
import config from '@app/config';
import { isJSON } from '@sharedHelpers/isJson';

export interface ErrorSchema {
  redirect: string;
  errorCode: number;
  errorMessage: string;
  success: boolean;
}

export interface ErrorReturn<T> {
  errorData: T;
  code: number;
}

export interface ExceptionResponse {
  errorCode: number;
  errorMessage: string;
  redirect: string;
  success: boolean;
}

export const NO_VALIDATE_TOKEN_CAPTCHA = 1037;

export const priorityHandleError = (error: AxiosError) => {
  if (error.response) {
    if (config.environment !== 'PRODUCTION') {
      console.log(error.response.data);
      console.log(error.response.status);
      console.log(error.response.headers);
    }
    toast.error(error);
    console.error('API error: ', error.message);
    console.trace();
    throw new ApiError(Number(error.code), error.message);
  } else {
    console.log(error.message);
  }
};

export const handleError = (error: AxiosError, response = null) => {
  if (error.response) {
    if (config.environment !== 'PRODUCTION') {
      console.log(error.response.status);
      console.log(error.response.headers);
    }

    return response;
  } else {
    console.log(error.message);
  }
};

export function handleResponseError<T>(error: AxiosError<ErrorSchema, any>): { error: ErrorReturn<T> } {
  let errorData;
  if (error.response?.data?.errorMessage) {
    if (isJSON(error.response?.data?.errorMessage)) {
      errorData = JSON.parse(error.response?.data?.errorMessage);
    } else {
      errorData = error.response?.data?.errorMessage;
    }
  } else {
    errorData = error.message || 'Ой ошибка :( Попробуйте еще раз.';
  }

  return {
    error: {
      errorData,
      code: error.response.status,
    },
  };
}
